<template>
  <div class="personalPage commBg">
    <div>

    </div>
  </div>
</template>
<script>
import http from '../../axios'
import { baseUrl } from '@/http/api.js'
import $ from 'jquery'
export default{
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    getOrderId () {
      // try {
      //   http.getOrderId().then(({ data }) => {
      //     // if (data.orderId === '' || data.orderId === undefined) {
      //     //   window.location.href = 'http://www.yinliuchi365.com/#/login'
      //     //   this.$router.go(0)
      //     // } else {
      //       window.location.href = baseUrl + '/api/order/pay?orderId=' + data.orderId
      //     // }
      //   })
      // } catch (err) {
      //   this.$message.error(err)
      // }
      let _this = this
      $.ajax({
        type: 'get',
        url: baseUrl + '/api/order/id',
        cache: false,
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'token': localStorage.getItem('token')
        },
        success: function (res) {
          if (res.orderId === 'undefined' || res.orderId==null){
            _this.$message.error('账号过期，请重新登录后再购买');
            return false;
          }
          window.location.href = baseUrl + '/api/order/pay?orderId=' + res.orderId
        }
      })
    }
  },
  mounted () {
    this.getOrderId()
  }
}
</script>
<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/views/pay/pay.vue